<div class="tile-for-assets _small-font">
  <div class="assets">
    @if (asset) {
      <p class="asset" [title]="asset">
        <rotec-icon-v2
          [svgIcon]="assetType"
          [color]="darkMode ? 'blue-lighter' : 'blue'"
        ></rotec-icon-v2>
        <span class="assetname" [class]="darkMode ? 'blue-lighter' : 'blue'">{{ asset }}</span>
      </p>
    }
    @if (compareAsset) {
      <p class="asset" [title]="compareAsset">
        <rotec-icon-v2
          [svgIcon]="referenceType"
          [color]="darkMode ? 'gray-lighter' : 'gray'"
        ></rotec-icon-v2>
        <span class="assetname" [class]="darkMode ? 'gray-lighter' : 'gray'">{{
          compareAsset
        }}</span>
      </p>
    }
  </div>
  @if (rotorType) {
    <p class="rotorType" [title]="compareAsset">
      <rotec-icon-v2 svgIcon="rotor" [color]="darkMode ? 'blue-lighter' : 'blue'"></rotec-icon-v2>
      <span class="assetname" [class]="darkMode ? 'blue-lighter' : 'blue'"> {{ rotorType }}</span>
    </p>
  }
</div>
